import { Grid, Stack, CircularProgress, Box, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { FileRejection } from 'react-dropzone';
import { useNavigate } from 'react-router-dom';
import readXlsxFile from 'read-excel-file';
import { ClientBulkUploadDTO } from 'wisestep-api';
import {
  FileTypeVariants,
  Label,
  WsButton,
  WsColors,
  WsFileUpload,
  WsIconDownload,
  WsTitleBanner,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import MapSpreadsheetColumns from './MapSpreadsheetColumns';

const LoaderBox = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  bgcolor: 'rgba(170, 164, 164, 0.16)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 2,
});

const BulkUploadSpreadsheets = () => {
  const [selectedClientFile, setSelectedClientFile] = useState<File>();
  const [parsedData] = useState<object>([]);
  const [newClientPayload, setNewClientPayload] = useState<ClientBulkUploadDTO[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (selectedClientFile) {
      setLoading(true);
      readXlsxFile(selectedClientFile)
        .then((rows) => {
          const clientArray = rows.map((row) => {
            const rowObject = row.reduce((acc, value, index) => {
              if (value) {
                acc[`column${index + 1}`] = value;
              }
              return acc;
            }, {});

            return {
              ...rowObject,
              name: null,
              linkedinUrl: null,
              industry: null,
              location: null,
              clientStatus: null,
              source: null,
              tags: null,
              description: null,
              firstName: null,
              lastName: null,
              emailAddress: null,
              phoneNumber: null,
              contactLocation: null,
              contactTags: null,
              position: null,
              linkedinProfile: null,
              uniqueId: null,
              ownerName: null,
              ownerEmail: null,
              allowedRecruiters: null,
              contactOwnerName: null,
              contactOwnerEmail: null,
              contactAllowedRecruiters: null,
              contactStatus: null,
            };
          });
          setNewClientPayload(clientArray as []);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [selectedClientFile]);

  const onFileUpload = async (files: File[]) => {
    setSelectedClientFile(files[0]);
    try {
      setNewClientPayload(newClientPayload);
    } catch (e) {
      console.log(e);
    }
  };

  const onFileRejected = (files: FileRejection[]) => {
    files.map((file) => {
      file.errors.map((error) => {
        console.log('rejected' + error.message);
      });
    });
    setLoading(false);
  };

  const downloadSampleFile = () => {
    window.open(
      'https://wisestep-open.s3.eu-west-1.amazonaws.com/upload_clients_sample_sheet.xlsx',
      '_blank'
    );
  };

  const navigate = useNavigate();

  return (
    <Grid>
      <WsTitleBanner title="Import Clients" goBack={() => navigate('/clients')} />
      <Grid>
        {newClientPayload.length > 0 && parsedData ? (
          <MapSpreadsheetColumns
            parsedData={newClientPayload}
            setNewClientPayload={setNewClientPayload}
          />
        ) : (
          <>
            <Box sx={{ position: 'relative', width: '100%' }}>
              <WsFileUpload
                name="clientSpreadsheet"
                onUpload={onFileUpload}
                placeholderText="Drag & drop .xls,.xlvs or .csv file < 1MB"
                fileTypes={FileTypeVariants.BULKUPLOAD}
                onFileRejected={onFileRejected}
                maxFileSize={2}
              />
              {loading && (
                <LoaderBox>
                  <CircularProgress />
                </LoaderBox>
              )}
            </Box>
            <Label sx={{ fontWeight: 'bold', my: 2, color: WsColors.TertiaryShades800 }}>
              Note:
            </Label>

            <Stack
              direction="row"
              justifyContent="flex-start"
              spacing={2}
              mb={2}
              alignItems="center"
            >
              <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SENARY}>
                Sample client Information format
              </WsTypography>

              <WsButton
                onClick={downloadSampleFile}
                variant="text"
                startIcon={<WsIconDownload color={WsColors.TheBlues500} />}
              >
                Download File
              </WsButton>
            </Stack>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default BulkUploadSpreadsheets;
